import { render, staticRenderFns } from "./VersionStickyNavbar.vue?vue&type=template&id=64de797f"
import script from "./VersionStickyNavbar.vue?vue&type=script&lang=ts"
export * from "./VersionStickyNavbar.vue?vue&type=script&lang=ts"
import style0 from "./VersionStickyNavbar.vue?vue&type=style&index=0&id=64de797f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports